export default "__VITE_ASSET__BWLPHKg1__"